import Reflux from 'reflux';

import actions from '../actions';
import configurationStore from './configuration-store';
import stateStore from './accessory-state-store';

import baseFacetStore from './base-facet-store';

export default Reflux.createStore(
	Object.assign({}, baseFacetStore, {
		init() {
			this.listenTo(configurationStore, this.onConfigurationChange);
			this.listenTo(stateStore, this.onStateChange);

			this.state = {
				facets: [],
				userSelection: {},
				filteredFacets: [],
				preselectionItemCounts: {},
				configuration: {
					facetRequirements: {},
					preselection: {},
					reducedFacets: [],
					visibleFacets: []
				}
			};
		},

		onLoadAccessoryFacetsCompleted(facets) {
			facets = this.state.configuration.visibleFacets.map(facetId => facets.find(facet => facet.id === facetId));
			facets = this._mapFacets(facets);

			const requirements = this.state.configuration.facetRequirements || {};
			if (requirements) {
				facets = this._applyFacetRequirements(facets, requirements);
			}

			this.state.facets = facets;
			actions.accessoryFacetsLoaded();
			this.output();
		},

		onStateChange(state) {
			this.state.userSelection = state.userSelection;
		},

		onConfigurationChange(configuration) {
			this.state.configuration = configuration.accessories;
			// we assume this does not change so we do not trigger here
		}
	})
);
